import React from "react";

const iconNameMap = {
  Calendar: "event",
  Check: "done",
  ChevronRight: "chevron_right",
  Database: "storage",
  FileText: "description",
  Filter: "filter_alt",
  Globe2: "public",
  Hash: "tag",
  Image: "image",
  Info: "info",
  Layers: "layers",
  Package: "inventory_2",
  RotateCcw: "restart_alt",
  Search: "search",
  Tags: "sell",
  Trash: "delete",
  User: "person",
  Users: "groups",
  X: "close",
  Truck: "local_shipping",
  Payments: "payments",
  DirtyLens: "dirty_lens",
  IDCard: "assignment_ind",
  LocationON: "location_on",
  Automation: "menu" /*in attesa di aggiornare supporto google icons*/,
};

const createMaterialIcon = (name) => {
  const Icon = ({ size = 16, className = "", ...props }) => (
    <span
      {...props}
      className={`material-icons ${className}`}
      style={{
        fontSize: size,
        lineHeight: 1,
        ...(props.style ?? {}),
      }}
    >
      {iconNameMap[name]}
    </span>
  );
  Icon.displayName = name;
  return Icon;
};

export const Calendar = createMaterialIcon("Calendar");
export const Check = createMaterialIcon("Check");
export const ChevronRight = createMaterialIcon("ChevronRight");
export const Database = createMaterialIcon("Database");
export const FileText = createMaterialIcon("FileText");
export const Filter = createMaterialIcon("Filter");
export const Globe2 = createMaterialIcon("Globe2");
export const Hash = createMaterialIcon("Hash");
export const Image = createMaterialIcon("Image");
export const Info = createMaterialIcon("Info");
export const Layers = createMaterialIcon("Layers");
export const Package = createMaterialIcon("Package");
export const RotateCcw = createMaterialIcon("RotateCcw");
export const Search = createMaterialIcon("Search");
export const Tags = createMaterialIcon("Tags");
export const Trash = createMaterialIcon("Trash");
export const User = createMaterialIcon("User");
export const Users = createMaterialIcon("Users");
export const X = createMaterialIcon("X");
export const Truck = createMaterialIcon("Truck");
export const Payments = createMaterialIcon("Payments");
export const DirtyLens = createMaterialIcon("DirtyLens");
export const IDCard = createMaterialIcon("IDCard");
export const LocationON = createMaterialIcon("LocationON");
export const Automation = createMaterialIcon("Automation");
